(function () {
	'use strict';
	$(document).ready(function () {

		const playVideo = (video) => {
			video.play();
			video.classList.add('playing');
			video.parentElement.classList.add('playing');
		};

		const pauseVideo = (video) => {
			video.parentElement.classList.remove('playing');
			video.classList.remove('playing');
			video.pause();
		};

		const handleVideo = (video) => {
			if (video.paused) {
				playVideo(video);
			} else {
				pauseVideo(video);
			}
		};

		document.querySelectorAll('video').forEach((videoElement) => {
			// const observer = new IntersectionObserver((entries, observerInstance) => {
			// 	const [entry] = entries;
			// 	if (entry.isIntersecting) {
			// 		playVideo(videoElement);
			// 		observerInstance.unobserve(videoElement);
			// 	}
			// }, { threshold: 0.15 });
			// observer.observe(videoElement);

			videoElement.addEventListener('click', () => {
				handleVideo(videoElement);
			});
			videoElement.addEventListener('ended', () => {
				pauseVideo(videoElement);
			});
			videoElement.nextElementSibling.addEventListener('click', () => {
				handleVideo(videoElement);
			});
		});


		// Handle contact form error
		document.addEventListener('wpcf7submit', function (event) {
			const responseOutputEl = event.target.querySelector('.wpcf7-response-output');
			responseOutputEl?.scrollIntoView();
		}, false);
	});
}(jQuery));
